module.exports = __webpack_public_path__ + "media/videos-icon.ec9030e5.png";